import { SIGNALS } from './SignalAudio'

/**
 * SignalscopeUI — 覗き込み中の HTML オーバーレイ（ビネット・クロスヘア・シグナル表示）。
 * DOM は index.html の #scopeOverlay に静的に置き、ここでは表示切替とテキスト更新だけを行う。
 */
export default class SignalscopeUI {
  constructor() {
    this.overlay = document.getElementById('scopeOverlay')
    this.nameElement = this.overlay?.querySelector('.scope-signal-name')
    this.freqElement = this.overlay?.querySelector('.scope-signal-freq')
    this.strengthBar = this.overlay?.querySelector('.scope-strength-bar')

    this.currentName = null

    // 追尾天体の切り替えボタン（Signalscope 側が onPrev / onNext を配線する）
    this.onPrev = null
    this.onNext = null
    this.overlay?.querySelector('.scope-prev')?.addEventListener('click', () => this.onPrev?.())
    this.overlay?.querySelector('.scope-next')?.addEventListener('click', () => this.onNext?.())
  }

  show() {
    if (!this.overlay) return
    this.overlay.classList.add('is-active')
    this.overlay.setAttribute('aria-hidden', 'false')
    // 覗き込み中はポートフォリオのHTML層をフェードアウトさせる（Signalscope.css 参照）
    document.body.classList.add('scope-mode')
  }

  hide() {
    if (!this.overlay) return
    this.overlay.classList.remove('is-active')
    this.overlay.setAttribute('aria-hidden', 'true')
    document.body.classList.remove('scope-mode')
    this.setSignal(null)
  }

  /** best: { name, level } | null */
  setSignal(best) {
    if (!this.overlay) return

    const name = best?.name ?? null

    // テキストは最良天体が切り替わった時だけ書き換える
    if (name !== this.currentName) {
      this.currentName = name
      const signal = name ? SIGNALS[name] : null
      this.nameElement.textContent = signal ? signal.label : '— NO SIGNAL —'
      this.freqElement.textContent = signal ? signal.freq : ''
      this.overlay.classList.toggle('has-signal', !!signal)
    }

    // 強度バーは毎フレーム更新してよい
    if (this.strengthBar) {
      this.strengthBar.style.width = `${Math.round((best?.level ?? 0) * 100)}%`
    }
  }
}
